export default __webpack_public_path__ + "static/media/bar_1.852c9519.jpg";